import { render, staticRenderFns } from "./EfsCardDialog.vue?vue&type=template&id=0fe47960&scoped=true"
import script from "./EfsCardDialog.vue?vue&type=script&lang=js"
export * from "./EfsCardDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe47960",
  null
  
)

export default component.exports